function telegramHref(value) {
    const source = String(value || '').trim();
    if (!source) return null;
    const match = source.match(/^(?:https?:\/\/)?(?:www\.)?(?:t\.me|telegram\.me)\/([^/?#]+)\/?$/i);
    const address = (match ? match[1] : source).replace(/^@+/, '');
    if (!/^[a-zA-Z0-9_]{5,64}$/.test(address) && !/^\+\d{7,15}$/.test(address)) return null;
    return `https://t.me/${address}`;
}

function telegramUsername(value) {
    const url = telegramHref(value);
    if (!url) return null;
    const username = url.slice('https://t.me/'.length);
    return username.startsWith('+') ? null : username;
}

function employeeTelegramUsername(employee) {
    if (!employee) return null;
    const linked = employee.telegram_contact || {};
    const username = telegramUsername(linked.username) || telegramUsername(linked.url);
    if (username) return username;
    const contacts = employee.contact_methods || employee.contacts || [];
    for (const contact of contacts) {
        if (!contact || String(contact.contact_type || contact.type || '').toLowerCase() !== 'telegram') continue;
        const value = telegramUsername(contact.url) ||
            telegramUsername(contact.value || contact.contact || contact.text);
        if (value) return value;
    }
    return null;
}

function employeeTelegramLinks(employee) {
    const result = [];
    const seen = new Set();
    const add = (value, label) => {
        const url = telegramHref(value);
        if (!url || seen.has(url.toLowerCase())) return;
        seen.add(url.toLowerCase());
        result.push({url, label: label || 'Открыть чат'});
    };
    const systemContact = employee && employee.telegram_contact;
    if (systemContact) {
        const username = String(systemContact.username || '').replace(/^@+/, '');
        add(systemContact.url || username, username ? `@${username}` : 'Открыть чат');
    }
    const contacts = employee && (employee.contact_methods || employee.contacts) || [];
    contacts.forEach(contact => {
        if (String(contact.contact_type || contact.type || '').toLowerCase() !== 'telegram') return;
        const value = contact.value || contact.contact || contact.text || '';
        add(contact.url || value, value);
    });
    return result;
}

module.exports = {telegramHref, telegramUsername, employeeTelegramUsername, employeeTelegramLinks};
